"use client";

import Image from "next/image";
import { EmailLoginForm } from "@/app/auth/EmailLoginForm";

export default function EmailLoginPage() {
    return (
        <div className="flex h-screen w-full">
            {/* Left side - Dark section with tagline */}
            <div className="relative hidden flex-col justify-between bg-black text-white md:flex md:w-1/2">
                <div className="absolute inset-0 bg-[url('/auth-background.png')] bg-cover bg-center opacity-100" />
                <div className="relative z-10 flex h-full flex-col justify-between p-12">
                    <div>
                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <foreignObject x="0" y="0" width="40" height="40">
                                <div className="flex h-full w-full items-center justify-center">
                                    <Image
                                        src="/logo-white.svg"
                                        alt="Mira Mace Logo"
                                        width={40}
                                        height={40}
                                        priority
                                    />
                                </div>
                            </foreignObject>
                        </svg>
                    </div>
                    <div>
                        <h1 className="mb-4 text-6xl leading-tight font-bold">
                            Your companion across the healthcare journey
                        </h1>
                    </div>
                </div>
            </div>

            {/* Right side - Email login form */}
            <div className="w-full bg-black md:w-1/2">
                <div className="flex h-full items-center justify-center p-1">
                    <div className="flex h-[99%] w-full max-w-[99%] flex-col items-center justify-center rounded-3xl border border-gray-300 bg-white p-8">
                        <div className="w-full max-w-md space-y-6">
                            <EmailLoginForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
